import React from 'react'

import i18n from 'live/services/i18n'

import { hasAdminPermission } from '../utils/permissions'
import { ResourceGroupList } from './components'
import { Container } from './styles'

export const ResourceGroupConfiguration: React.FC = () => {
    if (hasAdminPermission) {
        return (
            <Container>
                <ResourceGroupList />
            </Container>
        )
    } else {
        return (
            <Container>
                <div className="permissionAlert">
                    <h1>{i18n('YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE GROUP CONFIGURATION.')}</h1>
                </div>
            </Container>
        )
    }
}
